import { render } from "./DrawerApp.vue?vue&type=template&id=40088ff0"
import script from "./DrawerApp.vue?vue&type=script&lang=js"
export * from "./DrawerApp.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mvillegas\\Desktop\\coonfia-web\\repo-coonfia-web\\coonfia-mantenedor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__